"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionLinkState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var page_state_1 = require("./page.state");
/**
 * State for linking a collection to a vector field.
 */
var CollectionLinkState = /** @class */ (function () {
    function CollectionLinkState() {
    }
    Object.defineProperty(CollectionLinkState.prototype, "isLinking", {
        get: function () {
            return this.fieldId != null;
        },
        enumerable: false,
        configurable: true
    });
    CollectionLinkState.prototype.beginLinking = function (fieldId) {
        page_state_1.CurrentState.cancelInteractions();
        this.fieldId = fieldId;
    };
    CollectionLinkState.prototype.cancelLinking = function () {
        this.fieldId = null;
        this.collectionRevision = null;
    };
    CollectionLinkState.prototype.completeLinking = function (summary) {
        this.fieldId = null;
        this.collectionRevision = summary.revision;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionLinkState.prototype, "fieldId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionLinkState.prototype, "collectionRevision", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], CollectionLinkState.prototype, "isLinking", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionLinkState.prototype, "beginLinking", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionLinkState.prototype, "cancelLinking", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionLinkState.prototype, "completeLinking", null);
    return CollectionLinkState;
}());
exports.CollectionLinkState = CollectionLinkState;
//# sourceMappingURL=collection.link.state.js.map